module.exports = __webpack_public_path__ + "media/video_poster/mobile-4c1fb472.webp";